export const HEADTOHEAD = {
  "team_a": {
    "name": "Arsenal"
  },
  "team_b": {
    "name": "Liverpool"
  },
  "team_a_wins": 2,
  "team_a_draws": 3,
  "team_a_losses": 1,
  "statistics": [
    {
      "type": "GOALS_SCORED",
      "team_a_value": 10,
      "team_b_value": 12
    },
    {
      "type": "OVER_2_5_GOALS",
      "team_a_value": 4,
      "team_b_value": 6
    },
    {
      "type": "BOTH_TEAMS_SCORED",
      "team_a_value": 3,
      "team_b_value": 6
    }
  ],
  "matches": [
    {
      "link": [],
      "match_reference": {
        "id": 1,
        "external_reference": []
      },
      "match_date": "2016-09-18T17:00:00.000Z",
      "legs": 1,
      "leg": 1,
      "team_score_a": {
        "team": {
          "team_reference": {
            "id": 2,
            "external_reference": []
          },
          "name": "Liverpool"
        },
        "score": [
          {
            "score": "3"
          }
        ]
      },
      "team_score_b": {
        "team": {
          "team_reference": {
            "id": 1,
            "external_reference": []
          },
          "name": "Arsenal"
        },
        "score": [
          {
            "score": "4"
          }
        ]
      },
      "lineup_a": [],
      "lineup_b": [],
      "leg_score": [],
      "match_outcome": {
        "outcome": "WIN",
        "winner": {
          "name": "Arsenal",
          "team_reference": {
            "id": 1,
            "external_reference": []
          }
        }
      }
    },
    {
      "link": [],
      "match_reference": {
        "id": 2,
        "external_reference": []
      },
      "match_date": "2016-09-06T17:00:00.000Z",
      "legs": 1,
      "leg": 1,
      "team_score_a": {
        "team": {
          "team_reference": {
            "id": 1,
            "external_reference": []
          },
          "name": "Arsenal"
        },
        "score": [
          {
            "score": "0"
          }
        ]
      },
      "team_score_b": {
        "team": {
          "team_reference": {
            "id": 2,
            "external_reference": []
          },
          "name": "Liverpool"
        },
        "score": [
          {
            "score": "0"
          }
        ]
      },
      "lineup_a": [],
      "lineup_b": [],
      "leg_score": [],
      "match_outcome": {
        "outcome": "DRAW",
        "winner": {
          "name": "Arsenal",
          "team_reference": {
            "id": 2,
            "external_reference": []
          }
        }
      }
    }
  ]
}


// WEBPACK FOOTER //
// ./modules/Football/reducers/mockData/MockHeadToHeadData.js